export default "__VITE_ASSET__05e9aa12__"